<template>
  <div class="mb-4">
    <div
      class="bg-custom-light-green rounded-top d-lg-flex flex-row px-3 py-1 align-items-center bd-highlight"
    >
      <div class="d-flex flex-row w-80 bd-highlight">
        <div class="color-secondary-6 font-14 mr-1">
          Nombre de Custodio:
        </div>
        <div class="font-weight-bold font-16">
          {{ userName | empty }}
        </div>
      </div>
      <div>
        <custom-status-transaction
          :source="sourceDetails"
          :destination="destinationDetails"
        />
      </div>
    </div>

    <custom-callout
      has-toggle
      controlled
      class="border-radius-top-auto"
      :opened="isPanelOpen"
      :border-color="item.statusColor"
      @click:open="onToggle()"
    >
      <div class="row m-0 d-flex align-items-center">
        <div class="col-md col-12 p-md-0">
          <div class="py-3">
            <custom-balloon
              dot
              class="mt-2"
              :background-color="item.statusColor"
              :text="item.statusName"
            />
          </div>
        </div>
        <div class="col-md-10 col-12 mb-3 mb-lg-0 pl-md-0">
          <div class="row font-weight-normal">
            <div class="col-md-3 col-12">
              <div class="color-secondary-6 font-14">
                Título del Libro:
              </div>
              <div class="color-black font-16">
                {{ item.equipmentName | empty }}
              </div>
            </div>
            <div class="col-md-2 col-12">
              <div class="color-secondary-6 font-14">
                Código de Libro:
              </div>
              <div class="color-black font-16">
                {{ item.bookCode | empty }}
              </div>
            </div>
            <div class="col-md col-12">
              <div class="color-secondary-6 font-14 ">
                Número de Solicitud:
              </div>
              <div class="color-black font-16">
                {{ item.requestCode | empty }}
              </div>
            </div>
            <div class="col-md col-12">
              <div class="color-secondary-6 font-14 ">
                Fecha de Solicitud:
              </div>
              <div class="color-black font-16">
                {{ item.requestDate | date }}
              </div>
            </div>
            <div class="col-md-2 col-12">
              <drop-down
                :items="actionItems"
                always-show-dropdown
                class="float-md-right mt-2 mt-md-1"
              />
            </div>
          </div>
        </div>
      </div>
      <template #edition>
        <div v-if="showInfoSection" class="p-4">
          <div class="px-3 rounded-top bg-white">
            <custom-tab
              content-class="mt-3"
              nav-class="nav-vue-underline"
              no-nav-style
              @input="setCurrentTab"
              :defaultActiveTab="activeTab"
            >
              <custom-tab-item title="Información Adicional">
                <additional-info :transferId="item.id" />
              </custom-tab-item>
              <custom-tab-item
                v-if="item?.orderDetailId"
                title="Información  de Pedido"
              >
                <request-info :orderDetailId="item.orderDetailId" />
              </custom-tab-item>
              <custom-tab-item
                v-if="item.hasLog"
                title="Historial de Transferencia"
              >
                <transfer-history :transfer="item" />
              </custom-tab-item>
            </custom-tab>
          </div>
        </div>
        <div v-if="showCustomAcceptanceForm">
          <custom-action-form
            form-title="Razón de Aceptación"
            custom-icon="fa fa-check-circle text-orange"
            :form-info="item"
            :action="actions.ACCEPT"
            @close="onClosePanel"
            @save="approveTransfer"
          />
        </div>
        <div v-if="showCustomRejectionForm">
          <custom-action-form
            form-title="Razón de Rechazo"
            custom-icon="fa fa-times-circle text-orange"
            :form-info="item"
            :action="actions.REJECT"
            @close="onClosePanel"
            @save="rejectTransfer"
          />
        </div>
        <div v-if="showSendToRoute">
          <send-to-route
            :item="item"
            @close="onClosePanel"
            @refresh="onRefresh"
          />
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from "custom-callout";
import DropDown from "dropdown";
import CustomBalloon from "custom-balloon";
import CustomStatusTransaction from "../../inventoryOrderBooks/components/CustomStatusTransaction";
import CustomActionForm from "./CustomActionForm.vue";
import inventoryTransferService from "@/services/api/inventoryTransfer.api";
import transferStatuses from "@/utils/constants/inventory/peiAtServiceTransferStatus";
import SendToRoute from "./SendToRoute.vue";
import { CustomTab, CustomTabItem } from "custom-tabs";
import AdditionalInfo from "./AdditionalInfo.vue";
import RequestInfo from "./RequestInfo.vue";
import TransferInfo from "./TransferInfo.vue";
import TransferHistory from "./TransferHistory.vue";

const TEMPLATE_TAB_INDEX = {
  ADDITIONALINFO: 0,
  REQUESTINFO: 1,
  TRANSFERINFO: 2,
  TRANSFERHISTORY: 3
};

const ACTIONS = {
  ACCEPT: 0,
  REJECT: 1
};

const TEMPLATE_ACTION_INDEX = {
  ACCEPTANCEFORM: 0,
  REJECTIONFORM: 1,
  SEND_TO_ROUTE: 2,
  INFO: 3
};

export default {
  name: "TranferResultRow",
  components: {
    TransferInfo,
    CustomCallout,
    DropDown,
    CustomBalloon,
    CustomStatusTransaction,
    CustomActionForm,
    SendToRoute,
    CustomTab,
    CustomTabItem,
    AdditionalInfo,
    RequestInfo,
    TransferHistory
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({})
    },
    actionsToShow: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: false,
      currentAction: null,
      actions: [],
      book: {},
      actions: ACTIONS,
      activeTab: TEMPLATE_TAB_INDEX.ADDITIONALINFO
    };
  },
  computed: {
    showCustomAcceptanceForm() {
      return this.currentAction == TEMPLATE_ACTION_INDEX.ACCEPTANCEFORM;
    },
    showCustomRejectionForm() {
      return this.currentAction == TEMPLATE_ACTION_INDEX.REJECTIONFORM;
    },
    showInfoSection() {
      return this.currentAction == TEMPLATE_ACTION_INDEX.INFO;
    },
    showSendToRoute() {
      return this.currentAction === TEMPLATE_ACTION_INDEX.SEND_TO_ROUTE;
    },
    showInfoSection() {
      return this.currentAction === TEMPLATE_ACTION_INDEX.INFO;
    },
    userName() {
      return this.item?.user?.name || "";
    },
    sourceDetails() {
      return {
        title: this.item?.caatFrom ?? "Oficina Central",
        color: this.item?.caatFromColor ?? "#D3D3D3",
        icon: "custom-text-status fas fa-map-marker-alt mr-2"
      };
    },
    destinationDetails() {
      return {
        title: this.item?.caatTo,
        color: this.item?.caatToColor,
        icon: "custom-text-status fas fa-map-marker-alt mr-2"
      };
    },
    actionItems() {
      return [
        {
          name: "Enviar a Centro",
          icon: "fas fa-arrow-circle-right text-success",
          visible: this.item?.statusId == transferStatuses.Approved,
          click: () => {
            this.currentAction = TEMPLATE_ACTION_INDEX.SEND_TO_ROUTE;
            this.item.isOpen = !this.item.isOpen;
            this.$emit("open", this.item);
          }
        },
        {
          name: "Aceptar",
          icon: "fas fa-check-circle text-success",
          class: "border-bottom",
          visible: this.isApproveButtonVisible,
          click: () => this.showAcceptanceForm()
        },
        {
          name: "Rechazar",
          icon: "fas fa-times-circle text-danger",
          visible: this.isApproveButtonVisible,
          click: () => this.showRejectionForm()
        },
        {
          name: "Información Adicional",
          icon: "fas fa-info-circle text-success",
          click: () => this.showAdditionalInfo()
        },
        {
          name: "Información  de Pedido",
          icon: "fas fa-info-circle text-success",
          visible: Boolean(this.item?.orderDetailId),
          click: () => this.showRequestInfo()
        },
        {
          name: "Historial de Transferencia",
          icon: "fas fa-history text-success",
          visible: this.item.hasLog,
          click: () => this.showTransferHsitory()
        }
      ];
    },
    isPanelOpen() {
      return this.item.isOpen;
    },
    isApproveButtonVisible() {
      return (
        this.item?.statusId == transferStatuses.Submitted &&
        this.userHasPermissions("academic.books.transfer.approvetransfer")
      );
    },
    isRejectButtonVisible() {
      return (
        this.item?.statusId == transferStatuses.Submitted &&
        this.userHasPermissions("academic.books.transfer.rejecttransfer")
      );
    }
  },
  methods: {
    setCurrentTab(tab) {
      this.activeTab = tab;
    },
    async onToggle() {
      this.currentAction = TEMPLATE_ACTION_INDEX.INFO;
      this.setCurrentTab(TEMPLATE_TAB_INDEX.ADDITIONALINFO);

      if (this.item.isOpen) {
        this.isOpen = false;
        this.item.isOpen = false;
        this.$emit("close", this.item);
        return;
      }

      this.item.isOpen = true;
      this.isOpen = true;
      this.$emit("open", this.item);
    },
    showAcceptanceForm() {
      this.currentAction = TEMPLATE_ACTION_INDEX.ACCEPTANCEFORM;
      this.item.isOpen = !this.item.isOpen;
      this.$emit("open", this.item);
    },
    showRejectionForm() {
      this.currentAction = TEMPLATE_ACTION_INDEX.REJECTIONFORM;
      this.item.isOpen = !this.item.isOpen;
      this.$emit("open", this.item);
    },
    async approveTransfer(payload) {
      await inventoryTransferService.approveTransfer(this.item.id, payload);
      this.onToggle();
      this.$emit("refresh");
    },
    async rejectTransfer(payload) {
      await inventoryTransferService.rejectTransfer(this.item.id, payload);
      this.onToggle();
      this.$emit("refresh");
    },
    onClosePanel() {
      this.currentAction = null;
      this.onToggle();
    },
    onRefresh() {
      this.onClosePanel();
      this.$emit("refresh");
    },
    showAdditionalInfo() {
      this.currentAction = TEMPLATE_ACTION_INDEX.INFO;
      this.setCurrentTab(TEMPLATE_TAB_INDEX.ADDITIONALINFO);
      this.isOpen = true;
      this.$emit("open", this.item);
    },
    showRequestInfo() {
      this.currentAction = TEMPLATE_ACTION_INDEX.INFO;
      this.setCurrentTab(TEMPLATE_TAB_INDEX.REQUESTINFO);
      this.isOpen = true;
      this.$emit("open", this.item);
    },
    showTransfertInfo() {
      this.currentAction = TEMPLATE_ACTION_INDEX.INFO;
      this.setCurrentTab(TEMPLATE_TAB_INDEX.TRANSFERINFO);
      this.isOpen = true;
      this.$emit("open", this.item);
    },
    showTransferHsitory() {
      this.currentAction = TEMPLATE_ACTION_INDEX.INFO;
      this.setCurrentTab(TEMPLATE_TAB_INDEX.TRANSFERHISTORY);
      this.isOpen = true;
      this.$emit("open", this.item);
    }
  }
};
</script>
<style scoped lang="scss">
::v-deep .balloon-container.success {
  background-color: #a3e5b3;
}
::v-deep .balloon-container.warning {
  background-color: #f8b539;
}

.border-radius-top-auto ::v-deep .border-radius--light {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.bg-custom-light-green {
  background-color: #d9e5dfba;
}
.bg-custom-light-tracked {
  background-color: #f7f7f7;
}
.custom-tab {
  --tab-active-color: #ff7058 !important;
}
</style>
